exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-SlotWarnings .v-item-group>*{cursor:pointer}.v-SlotWarnings__item{border-width:3px;border-style:solid;border-color:transparent!important}.v-SlotWarnings--active{border-color:#00cae3!important}.sdr-chip--active{background:#ab3b7a}.sdr-chip--active .v-chip__content{color:#fff}.sdr-custom-text-input input{text-transform:uppercase}", ""]);

// exports
